<script lang="ts" setup>
import Svg from '@/components/Svg.vue';
import { mymobilityWordmark } from '@/assets';
import { computed } from 'vue';

import { useSessionStore } from '@/store';

const sessionStore = useSessionStore()

const props = defineProps({
  authenticated: {
    type: Boolean
  },
  /* Controls the width of the mymobility Wordmark. Options are:
   * "110" - sets the width to 110px wide.
   * "165" - sets the width to 165px wide.
   */
  width: {
    type: String
  }
});
const dashboardRoute = computed(() => {
  return sessionStore.isMagicLinkUser ? 'Dashboard.MLHome' : 'Dashboard.Home';
});

const navRouteName = computed(() => sessionStore.isProperProcedure ? dashboardRoute.value : 'Images.MedStrat')
</script>

<template>
  <component class="wordmark" :is="props.authenticated ? 'router-link' : 'div'"
    :to="props.authenticated ? { name: navRouteName } : null">
    <Svg :class="`wordmark-w-${props.width}`" :vector-paths="mymobilityWordmark.vectorPaths"
      :view-box="mymobilityWordmark.viewBox" />
  </component>
</template>

<style lang="scss" scoped>
.wordmark {
  // <a> or <div>
  display: block;
  line-height: 0;
  color: currentColor;

  &:focus,
  &:hover {

    &:not(.q-btn):not(.q-item):not(.q-tab) {
      text-decoration: none;
    }
  }

  &-w-110 {
    width: 110px;
  }

  &-w-165 {
    width: 165px;
  }
}
</style>
